module.exports = __webpack_public_path__ + "assets/Magen-Darm-Beschwerden.fd2af876.png";